var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"position":"bottom","get-container":"body","safe-area-inset-bottom":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('van-picker',{attrs:{"title":"人员选择","show-toolbar":"","columns":_vm.list},on:{"confirm":_vm.confirm,"cancel":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }